import PaymentMethod from "./PaymentMethod";

class AgencyBalanceTransaction {
    public id: string;
    public agencyId: string;
    public agencyBillingClosureId?: string;
    public paymentMethod?: PaymentMethod;
    public amount: number;
    public createdBy: string;
    public createdAt: number;
    public status: string;
    public remainingBalanceAfter: number;
    public comment?: string;

    constructor(
        id: string,
        agencyId: string,
        amount: number,
        createdAt: number,
        createdBy: string,
        status: string,
        remainingBalanceAfter: number,
        paymentMethod?: PaymentMethod,
        agencyBillingClosureId?: string,
        comment?: string,
    ) {
        this.id = id;
        this.agencyId = agencyId;
        this.agencyBillingClosureId = agencyBillingClosureId;
        this.amount = amount;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.status = status;
        this.paymentMethod = paymentMethod;
        this.comment = comment;
        this.remainingBalanceAfter = remainingBalanceAfter;
    }

}

export default AgencyBalanceTransaction;